<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Empresa"
                @click.stop="confirmarExcluirEmpresa()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        empresa: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluirEmpresa() {
            this.$swal({
                title: 'Empresa atendida',
                html: `Confirma a exclusão da empresa<br/><b>${this.empresa.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirEmpresa()
                }
            })
        },

        excluirEmpresa() {
            this.$emit('excluirEmpresa')
        }

        // registroSalvoComSucesso(data) {
        //     this.$toast.success(
        //         'Registro salvo com sucesso!',
        //         'OK',
        //         this.$toastConfig.success
        //     )
        //     this.$emit('obterDotacoesAtualizadas')
        // }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
